import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet";
import { Box, Tabs as MuiTabs, Tab as MuiTab, Typography as MuiTypography } from "@material-ui/core";
import { spacing } from "@material-ui/system";
import { useHistory, useLocation } from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";

import ParticipationSummaryTab from "./components/ParticipationSummaryTab.comp";
import ParticipationByMonthTab from "./components/ParticipationByMonthTab.comp";
import ParticipationByAgeTab from "./components/ParticipationByAgeTab.comp";
import ParticipationByGradeLevelTab from "./components/ParticipationByGradeLevelTab.comp";
import ParticipationByClassTab from "./components/ParticipationByClassTab.comp";
import {getSchools} from "../../../services/school.service";
import {useGlobalState} from "../../../context/global_state";
import {useParticipationData} from "./hooks/useParticipationData";
import {useAuth} from "../../../context/auth";

const Tabs = styled(MuiTabs)(spacing);
const Tab = styled(MuiTab)(spacing);
const Typography = styled(MuiTypography)(spacing);

function TabPanel({ children, value, index }) {
    return value === index && <Box py={3}>{children}</Box>;
}

const TAB_DEFS= () => [
    { key: "summary", label: "SUMMARY", path: "summary", component: <ParticipationSummaryTab /> },
    { key: "by_month", label: "BY MONTH", path: "by_month", component: <ParticipationByMonthTab /> },
    { key: "by_age", label: "BY AGE", path: "by_age", component: <ParticipationByAgeTab /> },
    { key: "by_grade_level", label: "BY GRADE LEVEL", path: "by_grade_level", component: <ParticipationByGradeLevelTab /> },
    { key: "by_class", label: "BY CLASS", path: "by_class", component: <ParticipationByClassTab /> },
];

const useStyles = makeStyles(theme => ({
    root:{
        backgroundColor: "grey",
        color: theme.palette.secondary.contrastText,
        margin: "0px 1px 0px 1px",
        padding: "0px 0px 0px 0px",
        minWidth: "auto",
        minInlineSize: "auto",

        "&.Mui-selected": {
            backgroundColor: theme.sidebar.background,
            color: theme.palette.secondary.contrastText,

        }
    },

    indicator: {
        backgroundColor: "primary",
        height: "100%",
        opacity: "0%",
        width: "100%",
    },

    link: {

    }
}));

function Participation() {
    const { authUser } = useAuth();
    const location = useLocation();
    const history = useHistory();
    const { pathname } = location;
    const basePath = `/${pathname.split('/')[1]}/school/participation`;
    const { settings } = useGlobalState();
    const selectedReport = settings.selected_report;
    const [school, setSchool] = useState('');
    const classes = useStyles();
    const tabDefs = TAB_DEFS();
    const { data, loading, error } = useParticipationData(
        authUser.org_code,
        selectedReport,
        school
    );

    const currentTabIdx = tabDefs.findIndex(tab =>
        pathname.startsWith(`${basePath}/${tab.path}`)
    );

    const handleTabChange = (e, idx) => {
        history.push(`${basePath}/${tabDefs[idx].path}`);
    };

    useEffect(() => {
        if (currentTabIdx === -1) {
            history.replace(`${basePath}/summary`);
        }
    }, [pathname]);

    useEffect(() => {
        const loadSchoolList = async (page = 0, rowsPerPage = 10, order = "asc", orderBy = undefined) => {
            try {
                const result = await getSchools(authUser.org_code, selectedReport, page, rowsPerPage, order, orderBy);
                if (result.data) {
                    console.log('Result School List --> ', result.data);
                    setSchool(result.data.data[0]?.school_name);
                }
            } catch (e) {
                console.log("Some error occurred while fetching progress data");
            }
        };
        // Call with default params or adjust as needed
        loadSchoolList();
    }, []);


    return (
        <React.Fragment>
            <Helmet title={"Participation"} />
            <Box width="100%" py={4}>
                <Tabs
                    value={currentTabIdx === -1 ? 0 : currentTabIdx}
                    onChange={handleTabChange}
                    TabIndicatorProps={{ className: classes.indicator }}
                    style={{paddingLeft: "30px", paddingRight: "30px"}}
                    centered
                    variant="fullWidth"
                    scrollButtons="auto"
                    aria-label="styled tabs example"
                >
                    {tabDefs.map(tabDef => (
                        <Tab
                            key={tabDef.key}
                            label={tabDef.label}
                            classes={{root: classes.root}}  style={{ fontWeight: "bold", fontSize: 16, minWidth: 200 }}/>
                    ))}
                </Tabs>
                <Box mt={3}>
                    {tabDefs.map((tabDef, idx) => (
                        <TabPanel key={tabDef.key} value={currentTabIdx} index={idx}>
                            {React.cloneElement(tabDef.component, { data, loading, error })}
                        </TabPanel>
                    ))}
                </Box>
            </Box>
            <LoaderWithBackDrop loading={loading} />
        </React.Fragment>
    );
}

export default Participation;
